var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 71,
    viewBox: "0 0 96 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M83.3026 21.0876V20.9976H83.3157L75.5467 15.1531V6.05325H63.4484L57.1612 1.32336H40.6436L34.7977 6.05325H24.0927V14.7119L16.3251 20.9976H16.3367V21.0876V61.0906L16.3251 61.1008H16.3367H83.3026H83.3157L83.3026 61.0906V21.0876Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9165 59.795H15.0101V19.7383H38.4012H56.7548H81.9165V59.795Z",
    fill: "#D12626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.992 19.7381H15L39.3185 0H55.8375L81.992 19.7381Z",
    fill: "#E96666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2244 4.78943H22.7021V50.071H74.2244V4.78943Z",
    fill: "#F8F8F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1164 16.1098H27.927V17.9965H49.1164V16.1098Z",
    fill: "#E1E1E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7253 20.7538H27.927V21.7698H69.7253V20.7538Z",
    fill: "#E1E1E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7253 22.4953H27.927V23.6564H69.7253V22.4953Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7253 24.3823H27.927V25.3982H69.7253V24.3823Z",
    fill: "#E1E1E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7253 26.1238H27.927V27.2848H69.7253V26.1238Z",
    fill: "#E1E1E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7253 28.0104H27.927V28.8812H69.7253V28.0104Z",
    fill: "#E1E1E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.228 29.8973H27.927V31.0584H56.228V29.8973Z",
    fill: "#E1E1E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9165 59.7947H15.0101V19.7641L37.4883 43.1639L57.8665 43.3932L81.9165 19.7641V59.7947Z",
    fill: "#C0D7D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.992 59.7947H15L39.3185 39.9115H55.8375L81.992 59.7947Z",
    fill: "#96B4B4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8592 61.8322C91.9075 56.7839 91.9075 48.599 86.8592 43.5507C81.8109 38.5024 73.626 38.5024 68.5777 43.5507C63.5294 48.599 63.5294 56.7839 68.5777 61.8322C73.626 66.8805 81.8109 66.8805 86.8592 61.8322Z",
    fill: "#E6E6E6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8453 52.4018L79.5944 45.3106V49.7793H69.29V55.2943H79.5944V59.4916L86.8453 52.4018Z",
    fill: "#0081AF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.49e3e24fae69532e5940e95fcd6a0ec5.svg";
export { ForwardRef as ReactComponent };